import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTag = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	fill: "none",
	viewBox: "0 0 20 20",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			stroke: "currentColor",
			strokeLinejoin: "round",
			strokeWidth: 1.5,
			d: "M1.75 3.856c0-1.163.943-2.106 2.106-2.106H9.3c.558 0 1.094.222 1.489.617l6.843 6.843a2.106 2.106 0 0 1 0 2.978l-5.445 5.445a2.106 2.106 0 0 1-2.978 0L2.367 10.79A2.106 2.106 0 0 1 1.75 9.3V3.857Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "currentColor",
			strokeLinejoin: "round",
			strokeWidth: 1.5,
			d: "M7.75 6.5a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0Z"
		})
	]
});
const ForwardRef = forwardRef(SvgTag);
export { ForwardRef as ReactComponent };
